import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import data from "../../Assets/data/books.json";
import { useNavigate } from "react-router-dom";
import { AspectRatio } from "@mui/joy";

const BooksSection = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  return (
    <>
      <Box>
        <Typography
          style={{ margin: "24px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Books
        </Typography>
        {data.map((book, i) => {
          return i < 3 ? (
            <Box
              style={{
                width: "100%",
                background: "#003366",
                padding: "32px",
                borderRadius: "16px",
                boxSizing: "border-box",
                marginBottom: "12px",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/publications/books");
              }}
            >
              <Grid container>
                <Grid item xs={2}>
                  <AspectRatio ratio="9/15">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "Images/BookCover/" +
                        book.image
                      }
                      alt="Book cover"
                      style={{ width: "-webkit-fill-available" }}
                    />
                  </AspectRatio>
                </Grid>
                <Grid item xs={9}>
                  <Typography
                    color="white"
                    style={{ marginLeft: "12px" }}
                    fontSize="28px"
                    sx={{
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                    }}
                  >
                    {book.title}
                  </Typography>
                  <Typography
                    color="white"
                    style={{ marginLeft: "12px" }}
                    sx={{
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 3,
                    }}
                  >
                    {book.description ? book.description : "No Description"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ) : null;
        })}
      </Box>
    </>
  );
});

export default BooksSection;
